import { Component, inject, ChangeDetectionStrategy } from '@angular/core'
import { CustomerNavigationService } from '@shared/services/customer-navigation.service'
import { RouterOutlet } from '@angular/router'

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [RouterOutlet],
})
export class AppComponent {
  private customerNavigationService = inject(CustomerNavigationService)

  constructor() {
    this.customerNavigationService.init()
  }
}
